export default "__VITE_ASSET__DM$USc6V__"